import { useTranslation } from 'react-i18next';

import Tooltip from 'components/tooltip/Tooltip';
import { TriggerState } from 'models/automation/Triggers';
import {
  ClockFillIconStyled,
  ExclamationCircleFillIconStyled,
} from './TriggerStateIcon.styles';

interface TriggerStateIconProps {
  state: TriggerState;
}

const TriggerStateIcon = ({ state }: TriggerStateIconProps) => {
  const { t } = useTranslation();
  const text = t('pageAutomations.triggers.triggerState', { context: state });

  if (state === TriggerState.CANCELLED) {
    return (
      <Tooltip id={`${state}-tooltip`} text={text}>
        <ExclamationCircleFillIconStyled aria-label={text} />
      </Tooltip>
    );
  }

  if (state === TriggerState.SCHEDULED) {
    return (
      <Tooltip id={`${state}-tooltip`} text={text}>
        <ClockFillIconStyled aria-label={text} />
      </Tooltip>
    );
  }

  return text;
};

export default TriggerStateIcon;
